export const encodeArrayBufferToBase64 = (arrayBufferData: ArrayBuffer) => {
  // Convert encrypted data to array of numbers
  const encryptedArray = Array.from(new Uint8Array(arrayBufferData));

  // Convert array of numbers to string
  const encryptedString = String.fromCharCode(...encryptedArray);

  // Convert string to base64
  const base64Encoded = window.btoa(encryptedString);

  return base64Encoded;
};
